export const iconFontAwesomeBuildingsBuildingUn = (
	<i className="fa-solid fa-building-un"></i>
);
